// frontend/src/components/AuthModal.tsx
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppContext } from '../context/AppContext';

const AuthModal: React.FC = () => {
  const { state, closeLoginModal } = useAppContext();
  const navigate = useNavigate();

  useEffect(() => {
    if (state.isLoginModalOpen) {
      closeLoginModal();
      navigate('/login');
    }
  }, [state.isLoginModalOpen, closeLoginModal, navigate]);

  return null;
};

export default AuthModal;